module.exports = __webpack_public_path__ + "img/heart-disabled.2ccd4b88.svg";